
import { Word } from "./Word";

export class Phrase {

  constructor(text) {
    this.text = text;

    this.words = this.splitWords();
  }

  splitWords() {
    var words = [];
    for (let word of this.text.split("-")) {
      words.push(new Word(word.trim()));
    }
    return words;
  }

  async effectivePhraseComplexity() {
    const wordComplexities = await Promise.all(
      this.words.map((word) => word.getEffectiveWordComplexity())
    );

    return wordComplexities.reduce((prev, curr) => prev + curr);
  }

  getWordParts() {
    return this.words;
  }

  containsWord(word) {
    for (const wordPart of this.words) {
      if (wordPart.text === word.text) {
        return true;
      }
    }
    return false;
  }

}